"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THColors = void 0;

var PIXI = _interopRequireWildcard(require("pixi.js"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var newColor = function newColor(value, data) {
  var color = value.toString(16);
  if (value > 0xFFFFFFFF) throw new Error("color value overflow: ".concat(color));
  var A = value & 0xFF;
  var rgb = value >>> 8;
  var B = rgb & 0xFF;
  var rg = rgb >>> 8;
  var G = rg & 0xFF;
  var R = rg >>> 8;
  var image = new Image();
  image.src = data;
  var texture = new PIXI.Texture(new PIXI.BaseTexture(image));
  return {
    value: value,
    data: data,
    hex: "#".concat(value.toString(16)),
    rgb: rgb,
    alpha: A,
    rgba: {
      R: R,
      G: G,
      B: B,
      A: A
    },
    image: image,
    texture: texture
  };
};

var THColors = {
  /** red */
  Reimu: newColor(0xCB1B45ff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAE0lEQVQoU2M8Le36nwEPYBwZCgDiuxFZv0b9QAAAAABJRU5ErkJggg=='),

  /** black */
  Marisa: newColor(0x1C1C1Cff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAE0lEQVQoU2OUkZH5z4AHMI4MBQAGEgqh6nJAewAAAABJRU5ErkJggg=='),

  /** yellow */
  Alice: newColor(0xE98B2Aff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAE0lEQVQoU2N82a31nwEPYBwZCgDzHRTxpXyovQAAAABJRU5ErkJggg=='),

  /** baka */
  Cirno: newColor(0x58B2DCff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAFElEQVQoU2OM2HTnPwMewDgyFAAAMsMXMXWBeqIAAAAASUVORK5CYII='),

  /** white */
  Sakuya: newColor(0xFCFAF2ff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAFElEQVQoU2P88+vTfwY8gHFkKAAA1JcfQVtkt10AAAAASUVORK5CYII='),

  /** green */
  Youmu: newColor(0x227D51ff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAE0lEQVQoU2NUqg38z4AHMI4MBQDO6A+BFQpJiAAAAABJRU5ErkJggg=='),

  /** sakura */
  Yuyuko: newColor(0xFEDFE1ff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAFElEQVQoU2P8d//hfwY8gHFkKAAAFOcd8YzlO0MAAAAASUVORK5CYII='),

  /** purple */
  Yakumo: newColor(0x4A225Dff, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAE0lEQVQoU2P0Uor9z4AHMI4MBQAdPA5J0HdVbgAAAABJRU5ErkJggg==')
};
exports.THColors = THColors;